import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { designHuddleService } from 'services';
import { displayNotification } from 'utils';

export const useDeleteProject = (
  clinid: string | undefined,
  isDeleteReviewRequest: boolean
) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      projectId,
      showNotification,
    }: {
      projectId: string;
      showNotification: boolean;
    }) => {
      return designHuddleService.deleteProject(
        clinid,
        projectId,
        isDeleteReviewRequest
      );
    },
    {
      onSuccess: async (data, variables, context) => {
        if (variables.showNotification) {
          displayNotification('Project successfully deleted');
        }

        queryClient.invalidateQueries({
          queryKey: [ServerStateKeysEnum.marketingProjects],
        });
      },
      // onError: () => {
      //   displayNotification('Failed to delete project', 'danger');
      // },
    }
  );
};
